import { useMutation, useQueryClient } from '@tanstack/react-query';
import useAuth from 'hooks/useAuth';
import { apiFetch } from 'utils/apiUtils';

interface MarkNotificationsAsReadVariables {
  ids: string[];
}

export default function useMarkNotificationsAsRead() {
  const { tokens } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['notifications', 'mark_as_read'],
    mutationFn: async ({ ids }: MarkNotificationsAsReadVariables) => apiFetch<void>({
      path: 'notifications/read',
      method: 'PATCH',
      accessToken: String(tokens.accessToken),
      body: { notificationIds: ids },
    }),
    onSuccess: () => {
      queryClient.refetchQueries({ queryKey: ['notifications'] });
    },
  });
}
